/* eslint-disable no-undef */
(function () {
  'use strict'

  angular.module('MktzapApp.Controllers')
    .controller('FormalizationProposalStatusSettingsController', formalizationProposalStatusSettingsController)

  formalizationProposalStatusSettingsController.$inject = ['$rootScope', 'CompanyService', 'NotificationService']

  function formalizationProposalStatusSettingsController ($rootScope, CompanyService, NotificationService) {
    $rootScope.getPageLabels('menu.config.formalizationProposalStatus')

    var vmFormalizationProposalStatusCtrl = this

    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vmFormalizationProposalStatusCtrl.metadata = data
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $rootScope.labels.errorLoadMeta)
      })

    vmFormalizationProposalStatusCtrl.allow = function () {
      CompanyService
        .saveMetadata(vmFormalizationProposalStatusCtrl.metadata)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = data
          NotificationService.successHandler(data, $rootScope.labels.saveConfig)
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorConfig)
        })
    }
  }
// eslint-disable-next-line semi
})();
